import { useTheme, Grid } from '@mui/material'
import { ReactComponent as WalterLearning } from '../assets/WalterLearning.svg'
import { ReactComponent as WalterSanteColor } from '../assets/WalterSanteColor.svg'
import { Stepper } from '.'
import { FormData, StepType } from '../utils/sharedTypes'
import { tunnelBrand } from '../utils/tunnelBrand'

type HeaderPropsType = {
  form?: FormData
  steps: StepType[]
  productCode?: string
}

const Header = ({ form, steps, productCode }: HeaderPropsType) => {
  const theme = useTheme()
  const edumiam = tunnelBrand()
  const product = form?.product || (form?.products && form.products.length > 0 ? form.products[0] : null)
  const displayProductCode = productCode || product?.product_code
  return (
    <Grid
      item
      container
      sx={{
        display: { xs: 'block', sm: 'none' },
        pt: 2,
        pl: 2,
        pr: 2,
        background: theme.palette.primary.light,
        height: 100,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Grid item container justifyContent="space-between" alignItems="center" sx={{ alignItems: 'baseline' }}>
        {edumiam ? (
          <edumiam.LogoComponent
            width={160}
            height={44}
            style={{ display: 'block', overflow: 'visible' }}
            onClick={() => {
              window.open(edumiam.websiteUrl, '_self')
            }}
          />
        ) : location.pathname.includes('/sante') ? (
          <WalterSanteColor
            width="162px"
            onClick={() => {
              window.open('https://walter-learning.com/sante', '_self')
            }}
          />
        ) : (
          <WalterLearning
            width="180px"
            onClick={() => {
              window.open('https://walter-learning.com', '_self')
            }}
          />
        )}
        <Grid item>
          {displayProductCode && (
            <img
              src={`https://walter-resources.s3.eu-west-3.amazonaws.com/formations/${displayProductCode.toLowerCase()}/img2/logotype_black.svg`}
              height="28px"
            />
          )}
        </Grid>
      </Grid>
      <Stepper steps={steps} />
    </Grid>
  )
}

export default Header
